module.exports = __webpack_public_path__ + "media/src/images/icons/statistics/primary-0a36e941e7114cb1a41897700f3a1739.svg";